module.exports = __webpack_public_path__ + "img/logo-yucatan-header.f74811c7.png";